module.exports = __webpack_public_path__ + "static/img/historyDataBg.acea5f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme1/common/historyDataBg.png
// module id = NFZ+
// module chunks = 319